import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'range'
})
export class RangePipe implements PipeTransform {

  transform(value: any, delimiter?: string): any {
    if (!value) {
      return '';
    }
    return value.min === value.max ? value.min : `${value.min}${delimiter}${value.max}`;
  }
}
